import { render, staticRenderFns } from "./SifrantZivaliDropDown.vue?vue&type=template&id=39e10cd0&"
import script from "./SifrantZivaliDropDown.vue?vue&type=script&lang=js&"
export * from "./SifrantZivaliDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports